import React, { useState } from 'react';
import Input from '../../input/Input';
import CidadeSearch from '../../../pages/geral/CidadeSearch';
import { useCidades } from '../../../contexts/geral/CidadeContext';


const EnderecoForm = ({ endereco, setEndereco }) => {
    const handleChange = (field, value) => {
        setEndereco({ ...endereco, [field]: value });
    };

    const { cidades } = useCidades(); // Ajuste para o contexto correto
    const [showSearchCidade, setShowSearchCidade] = useState(false);
    
        
    const handleSelectCidade = (cidadeSel) => {
        setEndereco({
            ...endereco,
            cidadeId: cidadeSel.id,
            cidade: cidadeSel, // Preenche o objeto cidade
        });
        
        setShowSearchCidade(false);
    };
    
    const handleCidadeExit = (cidadeId) => {
        const cidadeSelecionada = cidades.find(c => c.id.toString() === cidadeId.toString());
        if (cidadeSelecionada) {
            setEndereco({
                ...endereco,
                cidadeId: cidadeSelecionada.id,
                cidade: cidadeSelecionada, // Preenche o objeto cidade
            });
        } else {
            setEndereco({
                ...endereco,
                cidadeId: null,
                cidade: null, // Limpa caso a cidade não seja encontrada
            });
        }
    };

    return (
        
        <div className="section">            
            <h5>Endereço</h5>
            <div className="input-group">
                <Input
                    label="Logradouro"
                    value={endereco?.logradouro || ''}
                    onChange={(e) => handleChange('logradouro', e.target.value)}
                    size={300}
                />
                <Input
                    label="Número"
                    value={endereco?.numero || ''}
                    onChange={(e) => handleChange('numero', e.target.value)}
                    size={100}
                />
            </div>
            <div className="input-group">
                <Input
                    label="Bairro"
                    value={endereco?.bairro || ''}
                    onChange={(e) => handleChange('bairro', e.target.value)}
                    size={300}
                />
                <Input
                    label="Complemento"
                    value={endereco?.complemento || ''}
                    onChange={(e) => handleChange('complemento', e.target.value)}
                    size={300}
                />
            </div>
            <div className="input-group">
                <Input
                    label="CEP"
                    value={endereco?.cep || ''}
                    onChange={(e) => handleChange('cep', e.target.value)}
                    size={100}
                    mask="99999-999"
                />
                <Input
                    label="Cidade"
                    value={endereco?.cidadeId || ''}
                    onChange={(e) => handleChange('cidadeId', e.target.value)}
                    btnBuscar={() => setShowSearchCidade(true)}
                    onBlur={(e) => handleCidadeExit(e.target.value)}  
                    size={80}
                />
                <Input
                    value={endereco?.cidade?.nome || ''}
                    disabled
                    size={300}
                />
                <Input
                    label="UF"
                    value={endereco?.cidade?.uf || ''}
                    disabled
                    size={35}
                />
            </div>
            <CidadeSearch
                show={showSearchCidade}
                onHide={() => setShowSearchCidade(false)}
                onSelectCidade={handleSelectCidade}
            />            
        </div>
        
    );
};

export default EnderecoForm;
